import styled from 'styled-components';

// Components
import { DateTime } from '../../../inputs/DateTime';
import { InputTextArea } from '../../../inputs/InputTextArea';
import { Container } from '../../../inputs/InputTextArea/styles';
import { Typography } from '../../Typography';

// Types
import { RightArrowProps } from './types';
import { ButtonIconBackground } from '../../../inputs/buttons/ButtonIconBackground';
import { SpecialTag } from '../../SpecialTag';

export const ContainerOT = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.backgroundLila};
  border-radius: 0.8rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.l};
  }
`;

/* ContainerHeader / ContainerRefIcon / TagsContainer / ContainerTitleArrow
   viven en `../MainStyledComponents` y esta card los IMPORTA. Antes tenía
   copias locales sin las reglas responsive del 2026-07-31 (ROID encima de los
   chips, alineados a la derecha en tablet vertical), así que la card principal
   de la OT era la única que no se adaptaba mientras sus hijas sí. Una sola
   definición = imposible que vuelvan a divergir. */

export const RefRoid = styled(Typography)``;

/**
 * Vínculos recorrido ↔ OT (2026-09-24), en las dos caras: la card del
 * recorrido (sus OTs) y la de la OT o campaña (sus recorridos). Los vínculos
 * van en una fila propia a todo lo ancho del grupo de pills (flex-basis: 100%),
 * para que el estado y la CTA («Vincular OT» / «Vincular a recorrido») bajen
 * JUNTOS a la fila siguiente, alineados a la derecha como el resto del grupo.
 */
export const RouteLinksRow = styled.div`
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const RightArrow = styled.img<RightArrowProps>`
  transform: ${({ showInfo }) => (showInfo ? `rotate(90deg)` : null)};
  width: 1.4rem;
  height: 1rem;
  cursor: pointer;
`;

export const ContainerContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2.6rem;
  }
`;

export const ContainerData = styled.div`
  display: flex;
  margin-top: 3.2rem;
  gap: 2.6rem;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    margin-top: 2.6rem;
    gap: 2rem;
  }
`;

export const LocationGroup = styled.div`
  display: flex;
  gap: 2.6rem 1rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const ConcessionWrapper = styled.div`
  display: flex;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex: 0 0 auto;
    max-width: 10rem;
    min-width: 7rem;
  }
`;

export const RoadGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const PkGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const ClassificationTypeGroup = styled.div`
  display: flex;
  gap: 2.6rem 1rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const DateInput = styled(DateTime)`
  label {
    white-space: nowrap;
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2.9rem;
`;

/* D3 (2026-07-20, ajuste multi-resolución): fila propia para "Nombre del
   recorrido" en la card de la gemela del RV — dentro de ContainerDescription
   (flex-row sin wrap) el campo caía abajo-izquierda junto al textarea. */
export const RouteNameRow = styled.div`
  margin-top: 2rem;
  /* Nombre y Equipo comparten fila: los dos son campos del recorrido y solos
     dejaban media fila vacía cada uno. Se parten en dos líneas si no caben. */
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 2rem;
`;

export const InputDescription = styled(InputTextArea)`
  &${Container} {
    width: 100%;
  }
`;
export const SpecialTagStyled = styled(SpecialTag)`
  cursor: pointer;
`;
export const ButtonEdit = styled(ButtonIconBackground)``;
export const ButtonSave = styled(ButtonIconBackground)``;
